import React, {useRef, useContext} from 'react';
import {Card, ListGroup} from 'react-bootstrap';
import {MDBCheckbox} from 'mdb-react-ui-kit';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrash, faPencilAlt} from '@fortawesome/free-solid-svg-icons';
import {useNavigate} from 'react-router';
import {useParams} from 'react-router-dom';
import { MadricContext } from '../../../../Context/MadricContext';
import { updateNoteExtra } from '../../../../services/MadricService';

/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function Note(props) {

  const navigate = useNavigate();
  const {id} = useParams();
  const note = props.note
  const returnTo = 'historique'

  const {projectInfo, setProjectInfo} = useContext(MadricContext);
  
  const extra = useRef({
    extra1: props.note.extra1,
    extra2: props.note.extra2,
    extra3: props.note.extra3
  });

 /**
 * Permet de modifier les extras
 * @param {*} event event
 */
 async function handleChangeExtra(event) {
  extra.current = {
    ...extra.current,
    [event.target.name]: event.target.checked,
  };


  const updatedNote = projectInfo.map((p) => {
    if (p.id === props.note.id && p.type === 'note') {
      return {
        ...p,
        extra1: extra.current.extra1,
        extra2: extra.current.extra2,
        extra3: extra.current.extra3

      };
    }
    return p;
  });
  setProjectInfo(updatedNote);
  await updateNoteExtra(props.note.id, extra.current);
}


  return (
    <div className="checkin-container" key={props.note.id}>
      <Card className="checkin-card">
        <Card.Header className="checkin-header">
          <span style={{fontWeight: 'bold', textDecoration: 'underline'}}>NOTE</span> {props.formatDate(props.note.date)}
          <button className="checkin-pagination-button float-end" onClick={() => navigate('/UpdateNote', {state: {note, id, returnTo}})}><FontAwesomeIcon icon={faPencilAlt} /></button>
        </Card.Header>

        <ListGroup variant="flush">
          <ListGroup.Item className="checkin-list-item">
            Employé: {props.note.user_name}
          </ListGroup.Item>

          <ListGroup.Item>
            <MDBCheckbox
              name="extra1"
              id="inlineCheckbox111"
              defaultChecked={props.note.extra1}
              label="Extra possible"
              onChange={handleChangeExtra}
              inline
            />
            {localStorage.getItem('admin') === '1' ? (
              <React.Fragment>
                <MDBCheckbox
                  name="extra2"
                  id="inlineCheckbox222"
                  defaultChecked={props.note.extra2}
                  label="Extra valider"
                  onChange={handleChangeExtra}
                  inline
                />
                <MDBCheckbox
                  name="extra3"
                  id="inlineCheckbox333"
                  defaultChecked={props.note.extra3}
                  label="Extra confirmer"
                  onChange={handleChangeExtra}
                  inline
                />
              </React.Fragment>
            ) : (
              ' '
            )}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item ">
            Note: {props.note.note}
          </ListGroup.Item>
        </ListGroup>
      </Card>
    </div>
  );
}

export default Note;
